<template>
    <div>
           <!-- <div class="overConShow clearfix">
                 <div class="leftTab">
                     <ul>
                        <template v-for="(item,index) in list_category">
                                <li :key="index">
                                    <a href="javascript:void(0)"></a>
                                     <router-link :class="[item.id==id?'curr':'']" :key="index" :to="{name:'overview',params:{CategoryId:item.id}}">{{item.title}}</router-link>
                                </li>
                        </template>
                     </ul>
                 </div> -->
                
                <template v-if="dto.catType==1">
                    <div class="overConDesc">
                        <div class="descShow" v-html="utils.HandleContentImg(dto.content)"></div>
                    </div>
                </template>

                <template v-else>
                 <div class="unionNewsCon">
                      <template v-if="total==0">
                            <div class="nodataTip">
                                <div class="ico">
                                    <img src="../../assets/images/nodataTip.png" alt="">
                                </div>
                                <div class="text">暂无数据~</div>
                            </div>
                        </template>
                      <div class="list">
                           <ul>
                            <template v-for="(item,index) in list">
                               <li class="clearfix" :key="index">
                                   <router-link :to="{name:'uniondetail',params:{id:item.id}}">
                                      <div class="time">
                                          <span class="year">{{utils.DateFormat(new Date(item.publishDate),'yyyy')}}</span>
                                          <span class="date">{{utils.DateFormat(new Date(item.publishDate),'MM-dd')}}</span>
                                      </div>
                                      <div class="text_info">
                                           <img :src="item.imgUrl">
                                           <div class="infos">
                                               <div class="title">{{item.title}}</div>
                                               <div class="desc">{{item.content}}</div>
                                           </div>
                                      </div>
                                   </router-link>
                               </li>
                            </template>
                           </ul>
                      </div>
                      <Pagination v-model="pageindex" :total="total" :pagesize="pagesize" v-if="total>5" />
                 </div>
                 </template>
            <!-- </div> -->
    </div>
</template>
<script>
// import {Loading } from 'element-ui';
import Pagination from '../../components/Common/Pagination'
export default {
  data(){
    return{
        cid1: this.$route.query.cid1,
        id: this.$route.query.cid2,
        dto:{},
        list:[],
        total:0,
        pagesize:5,
        pageindex: 1,
    }
  },
  props:{
        r_cid1:{},
        r_cid2:{},
    },
  created(){
    this.Getcategory();
  },
  components:{
    Pagination
  },
  methods:{
        Getcategory(){
            if (!this.id) return;
            var url = "/pageapi/AssociationProfile/GetCategoryDetail";
            this.$http.post(url,{ID:this.id}).then(function(res){
                if (res.data.status==1){
                    this.dto=res.data.ds;
                    if (this.dto.catType==0){
                        this.GetList();
                    }
                }
            }.bind(this)).catch(function(){
            });
        },
     GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "/pageapi/AssociationProfile/GetList";
            this.$http.post(url,{pageindex: this.pageindex,pagesize: this.pagesize,CategoryId:this.id,}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.dto=res.data.ds;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },
        PropsChange() {
            if (this.pageindex!=1){
            this.pageindex=1;
            }else{
            this.GetList();
            }
        },
  },
  watch:{
        pageindex:function(){
            this.GetList();
        },
        r_cid1(){
            if (this.r_cid1>0){
                this.cid1=this.r_cid1;
            }
        },
        r_cid2(){
            if (this.r_cid2>0){
                this.id=this.r_cid2;
                this.Getcategory();
            }
        }
    }
}
</script>
